import { Duration } from 'ts-luxon';

export function mapDurationFromSysApi(duration: string | null | undefined): number {
	if (!duration) return 0;

	// Converts ISO 8601 time duration to ms
	return Duration.fromISO(duration).toMillis();
}

/**
 * Map uptime (ISO 8601 time duration) to [h]:mm:ss if it exists.
 * use `omitSeconds` to make string only accurate to HH:MM based on UX recommendation (ex: device uptime)
 */
export function mapUptimeDurationFromSysApi(
	duration: string | undefined | null,
	omitSeconds = false
): string | undefined {
	if (!duration) {
		return undefined;
	}

	return Duration.fromISO(duration).toFormat(omitSeconds ? 'hh:mm' : 'hh:mm:ss');
}
